import { Divider } from "antd";
import styled from "styled-components";

export const SCustomDivider = styled(Divider)`
  border-top: 1px solid #1b4040;
  width: 100%;
  margin: auto;
`;
